var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("loading", {
        attrs: { active: _vm.isLoading, loader: "dots" },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "text-center" }, [
        _c("img", {
          attrs: {
            width: "250",
            src: require("@/assets/img/no_record.png"),
            alt: "",
          },
        }),
        _c("br"),
        _c("span", [_vm._v(_vm._s(_vm.checkingStatus))]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }